// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"14983a57","925":"14983a57"}[chunkId] + ".chunk.css";
};